import SubcategoryFilter from './subcategory-filter';

export default SubcategoryFilter;
